import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Spinner from "../../Components/Spinner/Spinner";
import baseUrl from "../../baseUrl";

const UpdateBlog = () => {
  const token = JSON.parse(localStorage.getItem("admin-token"));
  const { id } = useParams();
  const navigate = useNavigate();

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  useEffect(() => {
    axios
      .get(`${baseUrl}/admin/single-blog/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setTitle(res.data.blog.title);
        setDescription(res.data.blog.description);
      });
  }, [id, token]);

  const handleUpdate = async (e) => {
    e.preventDefault();
    if (title && description) {
      axios
        .post(
          `${baseUrl}/admin/update-blog/${id}`,
          {
            title,
            description,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          if (res.data.success == true) {
            toast.success(res.data.message);
            navigate("/admin/all-blogs");
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  return (
    <>
      {title.length <= 0 && <Spinner />}
      <nav
        className=" w-auto container text-black font-bold mx-5 my-4"
        aria-label="Breadcrumb"
      >
        <h3 className="text-gray-700 text-3xl font-medium">Update Blog</h3>
      </nav>

      <div className="py-2">
        <div className="max-w-7xl mx-auto sm:px-6 lg:px-8">
          <div className="bg-white overflow-hidden shadow-sm sm:rounded-lg">
            <div className="p-6 bg-white border-b border-gray-200">
              <h3 className="pt-4 text-2xl text-center">Update Consultants</h3>
              <form onSubmit={handleUpdate}>
                <div className="mb-4">
                  <label className="text-xl text-gray-600">
                    Title <span className="text-red-500">*</span>
                  </label>

                  <input
                    type="text"
                    className="border-2 border-gray-300 p-2 w-full"
                    name="title"
                    id="title"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    required
                  />
                </div>

                <div className="mb-8">
                  <label className="text-xl text-gray-600">
                    Content <span className="text-red-500">*</span>
                  </label>
                  <textarea
                    name="content"
                    className=" p-2 w-full border-2 border-gray-300"
                    onChange={(e) => setDescription(e.target.value)}
                    value={description}
                    rows="10"
                  ></textarea>
                </div>

                <div className="flex p-1">
                  <button
                    type="submit"
                    className="p-3 bg-blue-500 text-white rounded-full hover:bg-blue-400"
                    required
                  >
                    Update Blog
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateBlog;
